"use client";
import { useRouter } from "next/navigation";
import React from "react";
import { PrismicImage } from "@prismicio/react";
import { PrismicNextLink } from "@prismicio/next";

const StyledButton = ({
  label = "",
  variant = "Primary",
  type = "button",
  icon = false,
  iconPosition = "Left",
  className = "",
  link = {},
  disabled = false,
  onClick = null,
}) => {
  const router = useRouter();

  const styleVariant =
    variant === "Primary"
      ? "bg-[#EEB978] hover:bg-[#EEB978]"
      : variant === "Secondary"
        ? "bg-[#FFFFFF] hover:bg-[#FFFFFF] border-[1px] border-[#232629]"
        : "";

  const buttonStyles = `flex font-bold items-center justify-center gap-x-[4px] text-[#232629] text-button py-[16px] px-[24px] transition-all ease-linear 0.3s ${disabled ? "opacity-45" : ""}`;

  return (
    <>
      {link?.url ? (
        <PrismicNextLink
          disabled={disabled}
          field={link}
          className={`${buttonStyles} ${styleVariant} ${className}`}
        >
          {icon && iconPosition === "Left" && (
            <PrismicImage field={icon} className="w-[20px]" alt="" />
          )}
          {label}
          {icon && iconPosition === "Right" && (
            <PrismicImage field={icon} className="w-[20px]" alt="" />
          )}
        </PrismicNextLink>
      ) : (
        <button
          disabled={disabled}
          type={type}
          className={`${buttonStyles} ${styleVariant} ${className}`}
          onClick={() => {
            if (onClick) {
              onClick();
            } else if (link?.url) {
              router.push(link?.url);
            }
          }}
        >
          {icon && iconPosition === "Left" && (
            <PrismicImage field={icon} className="w-[20px]" />
          )}
          {label}
          {icon && iconPosition === "Right" && (
            <PrismicImage field={icon} className="w-[20px]" />
          )}
        </button>
      )}
    </>
  );
};

export default StyledButton;
